import { Box, Tab as MUITab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { Input, Loader } from '@/shared/ui';
import { useMetaOauthCode } from '../../model/useMetaOauthCode';
import { EventPostbacksTable } from '../EventPostbacksTable/EventPostbacksTable';
import { MetaButton } from '../MetaButton/MetaButton';

const Tab = styled(MUITab)(({ theme }) => ({
  minHeight: 0,
  padding: `${theme.spacing(1.25)} ${theme.spacing(2)}`,
  textTransform: 'none',
}));

const IntegrationTab = {
  datasources: 'datasources',
  eventPostbacks: 'eventPostbacks',
} as const;
type IntegrationTabKeys = (typeof IntegrationTab)[keyof typeof IntegrationTab];

interface Props {
  integrationsSlot: ReactNode[];
}

export function IntegrationPanel({ integrationsSlot }: Props) {
  const { inProgress, openDataAccessDialog } = useMetaOauthCode();
  const [tab, setTab] = useState<IntegrationTabKeys>(
    IntegrationTab.datasources,
  );

  const handleTabChange = (
    _event: React.SyntheticEvent,
    newTab: IntegrationTabKeys,
  ) => {
    setTab(newTab);
  };

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Tabs value={tab} onChange={handleTabChange}>
        <Tab value={IntegrationTab.datasources} label="Datasources" />
        <Tab value={IntegrationTab.eventPostbacks} label="Event Postbacks" />
      </Tabs>
      {tab === IntegrationTab.datasources && (
        <Box sx={{ flexGrow: 1, position: 'relative' }}>
          <MetaButton onClick={openDataAccessDialog} />
          <Box
            sx={{
              position: 'absolute',
              top: 60,
              left: 0,
              right: 0,
              bottom: 0,
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            {integrationsSlot}
            <Loader active={inProgress} />
          </Box>
        </Box>
      )}
      {tab === IntegrationTab.eventPostbacks && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: 300,
            }}
          >
            <Input label="Meta App Id" />
            <Input label="Meta Pixel Id" />
          </Box>
          <EventPostbacksTable />
        </Box>
      )}
    </Box>
  );
}
